import type {
  SeverityGrid,
  UseGetSeverityGridProps,
} from "./severity-grid.type";

import { useGet } from "@/hooks/queries";

export const useGetSeverityGrid = ({
  assetTypeId,
  severityGridId,
  options,
}: UseGetSeverityGridProps) => {
  const { data, ...queryResult } = useGet<SeverityGrid>(
    "severityGrids",
    severityGridId,
    {
      rootId: assetTypeId,
      enabled: !!assetTypeId,
      neverStale: true,
      ...options,
    }
  );

  return {
    severityGrid: data,
    ...queryResult,
  };
};
